import { useState } from 'react';
import { useAuth } from '../../firebase/useAuth';
import styles from './SignInBanner.module.css';

export default function SignInBanner() {
  const { user, signInWithGoogle } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('signInBannerDismissed') === '1'
  );

  if (user || dismissed) return null;

  function handleDismiss() {
    sessionStorage.setItem('signInBannerDismissed', '1');
    setDismissed(true);
  }

  return (
    <div className={styles.banner}>
      <span className={styles.message}>Sign in to sync your collection across devices</span>
      <button className={styles.signInBtn} onClick={signInWithGoogle}>
        Sign in with Google
      </button>
      <button className={styles.dismiss} onClick={handleDismiss} aria-label="Dismiss">
        ✕
      </button>
    </div>
  );
}
